import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input, Slider, TableCell, TableRow } from '@mui/material';
import { camelToDisplay } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
export function SimpleNumberRowGeneric({ payloadAttribute, setPayloadAttribute, setHasEdits, k, v, reportedValue, currentValue, limits, min, max, marks, step, keyWidth, inputWidth, i, }) {
    const handleNumberChange = (e, k) => {
        const value = parseInt(e.target.value);
        const { attributeType, range: { min, max }, } = limits;
        debug && console.log(limits);
        if (value >= min && value <= max) {
            setPayloadAttribute(value, k);
        }
        else {
            debug && console.log('do something with err');
        }
    };
    return (_jsxs(TableRow, { children: [_jsx(TableCell, { style: { width: keyWidth }, children: camelToDisplay(k) }, `key_${String(k)}`), _jsx(TableCell, { style: { width: inputWidth }, children: reportedValue }, `reported`), _jsx(TableCell, { style: { width: inputWidth, color: v === reportedValue ? 'inherit' : 'red' }, children: v }, `val`), _jsx(TableCell, { style: { width: inputWidth }, children: _jsx(Input, { type: 'number',
                    style: { width: inputWidth },
                    value: payloadAttribute?.[k] ?? 0,
                    onChange: (e) => {
                        setHasEdits(true);
                        handleNumberChange(e, k);
                    } }) }, `input`), _jsx(TableCell, { style: { width: inputWidth }, children: _jsx(Slider, { value: currentValue ?? min,
                    marks,
                    min,
                    max,
                    step,
                    color: v === reportedValue ? 'primary' : 'secondary',
                    getAriaValueText: (v, i) => v.toString(),
                    'aria-labelledby': 'discrete-slider',
                    valueLabelDisplay: 'auto',
                    onChangeCommitted: (e, sVal) => {
                        e.preventDefault();
                        e.stopPropagation();
                        sVal = sVal instanceof Array ? sVal[0] : sVal;
                        setHasEdits(true);
                        setPayloadAttribute(sVal, k);
                    } }) }, `slider`)] }, `r_${i}`));
}
